import type { GridColDef } from '@mui/x-data-grid';

import { nameof } from '@e-socna/utils';

import type { CompatibleSectionTemplates_SectionTemplates } from './hooks/useFindAllCompatibleSectionTemplatesQuery.hook';

export const columns: readonly GridColDef<CompatibleSectionTemplates_SectionTemplates>[] =
  [
    {
      field: nameof<CompatibleSectionTemplates_SectionTemplates>('code'),
      headerName: 'Code',
      width: 200,
      description: 'Code',
      editable: false,
      sortable: true,
      type: 'string',
    },
    {
      field: nameof<CompatibleSectionTemplates_SectionTemplates>('label'),
      headerName: 'Libellé',
      width: 400,
      description: 'Libellé',
      editable: false,
      sortable: true,
      type: 'string',
    },
  ];
